window.SOURCE_IDENTITIES = {
  "cities": [
    {
      "name": "New York",
      "sourceVariantId": "51443046646069"
    },
    {
      "name": "Las Vegas",
      "sourceVariantId": "51443046744373"
    },
    {
      "name": "Toronto",
      "sourceVariantId": "51443046842677"
    },
    {
      "name": "Tokyo",
      "sourceVariantId": "51443046940981"
    },
    {
      "name": "Tokyo Fujiyama",
      "sourceVariantId": "51443047039285"
    },
    {
      "name": "Tokyo Sakura",
      "sourceVariantId": "51443047137589"
    },
    {
      "name": "Paris",
      "sourceVariantId": "51443047235893"
    },
    {
      "name": "Los Angeles",
      "sourceVariantId": "52819076776245"
    },
    {
      "name": "Chicago",
      "sourceVariantId": "52819076383029"
    },
    {
      "name": "San Francisco",
      "sourceVariantId": "52819076841781"
    },
    {
      "name": "Venice",
      "sourceVariantId": "51443047334197"
    },
    {
      "name": "Seoul",
      "sourceVariantId": "51443047432501"
    },
    {
      "name": "Florence",
      "sourceVariantId": "51443047530805"
    },
    {
      "name": "Berlin",
      "sourceVariantId": "51443047629109"
    },
    {
      "name": "Bangkok",
      "sourceVariantId": "51443047727413"
    },
    {
      "name": "Singapore",
      "sourceVariantId": "51443047825717"
    },
    {
      "name": "Budapest",
      "sourceVariantId": "51443047924021"
    },
    {
      "name": "Hamburg",
      "sourceVariantId": "51443048022325"
    },
    {
      "name": "Cologne",
      "sourceVariantId": "51443048120629"
    },
    {
      "name": "London Big Ben",
      "sourceVariantId": "51443048218933"
    },
    {
      "name": "London Tower Bridge",
      "sourceVariantId": "51443048317237"
    },
    {
      "name": "Sydney",
      "sourceVariantId": "51443048415541"
    },
    {
      "name": "India Taj Mahal",
      "sourceVariantId": "51443048513845"
    },
    {
      "name": "Venice Canal",
      "sourceVariantId": "51443048612149"
    },
    {
      "name": "Amsterdam",
      "sourceVariantId": "51443048710453"
    },
    {
      "name": "Cappadocia",
      "sourceVariantId": "51443048808757"
    },
    {
      "name": "Hong Kong",
      "sourceVariantId": "51443049005365"
    },
    {
      "name": "Kuala Lumpur",
      "sourceVariantId": "51443049103669"
    },
    {
      "name": "Dream Castle",
      "sourceVariantId": "51443049201973"
    },
    {
      "name": "Carnival",
      "sourceVariantId": "51443049300277"
    }
  ],
  "nature": [
    {
      "name": "Hummingbird",
      "sourceVariantId": "51289070862645"
    },
    {
      "name": "Northern Lights",
      "sourceVariantId": "51289070960949"
    },
    {
      "name": "Rainy Day",
      "sourceVariantId": "51289071059253"
    },
    {
      "name": "Bees & Daisies",
      "sourceVariantId": "52819079528757"
    },
    {
      "name": "Lilypad Dreams",
      "sourceVariantId": "51289071157557"
    },
    {
      "name": "Yellowstone Cubs",
      "sourceVariantId": "51289071255861"
    },
    {
      "name": "KoalaHugz",
      "sourceVariantId": "51289071354165"
    },
    {
      "name": "Swans Lake",
      "sourceVariantId": "51289071452469"
    },
    {
      "name": "Climb Me To The Moon",
      "sourceVariantId": "51289071550773"
    },
    {
      "name": "Mouse & Dandelion",
      "sourceVariantId": "52819079594293"
    },
    {
      "name": "Cat & Butterfly",
      "sourceVariantId": "52819079659829"
    },
    {
      "name": "Polar Bears [ New ]",
      "sourceVariantId": "53250126250293"
    },
    {
      "name": "Lovebirds [ New ]",
      "sourceVariantId": "53264760045877"
    },
    {
      "name": "Hawk [ New ]",
      "sourceVariantId": "53264760111413"
    },
    {
      "name": "Horse [ New ]",
      "sourceVariantId": "53264760176949"
    },
    {
      "name": "Camels [ New]",
      "sourceVariantId": "53264760242485"
    },
    {
      "name": "Chipmunk [ New ]",
      "sourceVariantId": "53264760308021"
    },
    {
      "name": "Flamingos [ New ]",
      "sourceVariantId": "53264760373557"
    },
    {
      "name": "Leopard [ New ]",
      "sourceVariantId": "53264760439093"
    },
    {
      "name": "Lion Cub [ New ]",
      "sourceVariantId": "53264760504629"
    },
    {
      "name": "Otters [ New ]",
      "sourceVariantId": "53264760570165"
    },
    {
      "name": "Seals [ New ]",
      "sourceVariantId": "53264760635701"
    },
    {
      "name": "Sunflower [ New ]",
      "sourceVariantId": "53264760701237"
    }
  ],
  "japan": [
    {
      "name": "Great Wave Off Kanagawa - 神奈川沖浪裏",
      "sourceVariantId": "51313613603125"
    },
    {
      "name": "Dragon and Thunder - 龍と雷",
      "sourceVariantId": "51313613701429"
    },
    {
      "name": "Tiger Rise - 虎の昇り",
      "sourceVariantId": "51313613799733"
    },
    {
      "name": "Phoenix Rebirth - 環",
      "sourceVariantId": "51313613898037"
    },
    {
      "name": "Koi Dreams - 鯉の夢",
      "sourceVariantId": "51313613996341"
    },
    {
      "name": "Celestial Peacock - 天の孔雀",
      "sourceVariantId": "51313614094645"
    },
    {
      "name": "Geisha's True Spirit - 不撓不屈",
      "sourceVariantId": "51313614192949"
    }
  ],
  "wildlife": [
    {
      "name": "The Jungle (Zebra + Lion + Jaguar + Elephant)",
      "sourceVariantId": "51482418348341"
    },
    {
      "name": "Under The Sea (Whale + Dolphins + Jellyfish + Turtle)",
      "sourceVariantId": "51482418446645"
    },
    {
      "name": "Tropical Forest (Tiger + Wolf + Monkey + Tucan)",
      "sourceVariantId": "51482418544949"
    },
    {
      "name": "Lost Kingdom (Unicorn + Dragon + Fairy + Jixy)",
      "sourceVariantId": "51482418643253"
    }
  ]
};
